import React from 'react';
 
const HomePage = () => {
    return (
      <div class = 'container projects'>
        <h1>React Dance</h1>
        <div class="overlay"></div>
      </div>
    );
}
 
export default HomePage;